import(/* webpackMode: "eager" */ "/home/runner/work/apollo/apollo/apps/healthcare.com/src/app/error.tsx");
